import './ChanceSlider.css';

type ChanceSliderProps = {
    chance: number;
    onChange: (chance: number) => void;
};

export const ChanceSlider = ({ chance, onChange }: ChanceSliderProps) => {
    return (
        <div className="chance-slider">
            <input type="range" min={0} max={100} step={0.1} value={chance * 100} onChange={(e) => onChange(parseFloat(e.target.value) / 100.0)} />
            <span>{(chance * 100).toFixed(1)}%</span>
        </div>
    );
};